import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, Columns, Tabs } from "@namroodinc/ni-ui";

import SportsCard from "../../SportsCard/index.js";
import Round from "./Round.js";

const MMAHeadToHead = (props) => {
  const [typeOfValue, setTypeOfValue] = useState("percentage");
  return props.data.allRoundsStatistics.length > 0 ? (
    <SportsCard
      event={props.data.event}
      headToHead={props.data.allFighters}
      displayPicSize="small"
      topper={{
        ...props.data.event,
        brandProfiling: "background",
        displayPicSize: "large"
      }}
      type="scores"
      {...props.data.event}
    >
      <Columns numberOfColumns={1} gap={"md"}>
        <Tabs
          control={
            <Button
              label={
                typeOfValue === "percentage"
                  ? "View Raw Data (x/y)"
                  : "View Percentages (%)"
              }
              onClick={() =>
                setTypeOfValue(
                  typeOfValue === "percentage" ? "notes" : "percentage"
                )
              }
              size={"small"}
            />
          }
          responsive={false}
          tabs={props.data.allRoundsStatistics.map((round, index) => {
            return {
              label: props.data.roundGroupNames[index],
              content: (
                <div key={index}>
                  <Round
                    data={props.data}
                    event={props.data.event}
                    round={round}
                    typeOfValue={typeOfValue}
                  />
                </div>
              )
            };
          })}
          type="dropdown"
        />
      </Columns>
    </SportsCard>
  ) : null;
};

MMAHeadToHead.propTypes = {
  data: PropTypes.object
};

MMAHeadToHead.defaultProps = {
  data: {
    allRoundsStatistics: [],
    roundGroupNames: []
  }
};

export default MMAHeadToHead;
